import config from "../config";
import storage from 'local-storage-fallback'

import Cookies from 'universal-cookie';

const cookies = new Cookies();
const mixpanel = require('mixpanel-browser');
mixpanel.init("c805ed9c4e73d1093d18978a1d79ed1b");


export default {
    login,
    invite,
    logout,
    getAll
};


function invite(email) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({email})
    };

    mixpanel.identify(getUserToken());
    mixpanel.track('landlord invite sent', {
        'landlord invite': email
    });

    return fetch(config.apiGateway.URL + '/invite', requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response;
        })
        .then(user => {
            // login successful if there's a jwt token in the response
            console.log('response ' + user)

            return user;
        });
}

function login(email) {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({"email": email})
    };

    mixpanel.track('agent verification attempt', {
        'agent email': email
    });

    return fetch(config.apiGateway.URL + '/login', requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.text();
        })
        .then(user => {
            return user;
        });
}

function logout() {
    try {
        localStorage.removeItem('user');
    } catch (e) {
        console.log("failed to remove local storage")
    }
    cookies.remove('user');
}

function authHeader() {
    // return authorization header with jwt token

    let user = null
    try {
        user = localStorage.getItem('user');
    } catch (e) {
        user = cookies.get("user")
    }

    if (user) {
        return {'Authorization': 'Bearer ' + user.token};
    } else {
        return {};
    }
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch('/users', requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (!response.ok) {
        return Promise.reject(response.statusText);
    }

    return response.json();
}


export async function authUser() {
    return authHeader() != null;
}

function authHeader() {
    // return authorization header with jwt token
    let user = null
    try {
        user = localStorage.getItem('user');
    } catch (e) {
        user = cookies.get('user');
    }

    if (user) {
        return {'Authorization': 'Bearer ' + user};
    } else {
        return null;
    }
}

function getUserToken() {
    let user = null
    try {
        user = localStorage.getItem('user');
    } catch (e) {
        user = cookies.get('user');
    }

    return user
}

export function signOutUser() {
    console.log('remove ')
    cookies.remove("user")
    try {
        localStorage.removeItem("user")
    } catch (e) {

    }
    cookies.remove("user")
}


// WEBPACK FOOTER //
// ./src/libs/apiLib.js